import React from 'react';
import styled from 'styled-components';
import { withRouter } from 'react-router-dom';

import {
  Input,
  ReactDateTimePicker,
  Select,
} from '../../../components/elements';

import { unformatted_localizedDate } from '../../../utils/localizedDate';

const Wrapper = styled.nav`
  padding: 1rem;
  border-bottom: 1px solid #f5f8fa;
  padding-bottom: 1rem;
`;

const BoxWrapper = styled.nav`
  &&& {
    background: #f6f6f6;
  }
`;

const PlaceSearch = ({ search, clearPagination, handlePush }) => (
  <Wrapper>
    <BoxWrapper className="box">
      <div className="columns">
        <div className="column is-2">
          <Input
            label="Place Name"
            type="text"
            value={search.placename}
            onChange={e => {
              clearPagination();
              handlePush({ placename: e.target.value }, 'placename');
            }}
          />
        </div>
        <div className="column is-2">
          <Input
            label="User Name"
            type="text"
            value={search.username}
            onChange={e => {
              clearPagination();
              handlePush({ username: e.target.value }, 'username');
            }}
          />
        </div>
        <div className="column is-3">
          <Input
            label="User Email"
            type="text"
            value={search.useremail}
            onChange={e => {
              clearPagination();
              handlePush({ useremail: e.target.value }, 'useremail');
            }}
          />
        </div>
        <div className="column is-3">
          <Input
            label="User Phone"
            type="text"
            value={search.userphone}
            onChange={e => {
              clearPagination();
              handlePush({ userphone: e.target.value }, 'userphone');
            }}
          />
        </div>
        <div className="column is-2">
          <Select
            label="Payment Method"
            options={[{ label: 'CARD', value: 'CARD' }]}
            value={[{ label: 'CARD', value: 'CARD' }]}
            disabled
          />
        </div>
      </div>
      <div className="columns">
        <div className="column is-2">
          <Input
            label="Order Reference"
            type="text"
            value={search.orderRef}
            onChange={e => {
              clearPagination();
              handlePush({ orderRef: e.target.value }, 'orderRef');
            }}
          />
        </div>
        <div className="column is-2">
          <Select
            label="Payment Status"
            options={[
              { label: 'All', value: 'PAID_AND_PARTIAL_REFUND' },
              { label: 'Paid', value: 'PAID' },
              { label: 'Partial Refund', value: 'PARTIAL_REFUND' },
              { label: 'Full Refund', value: 'FULL_REFUND' },
            ]}
            disableToastMessage
            value={search.paymentStatus}
            onChange={e => {
              clearPagination();
              handlePush({ paymentStatus: e.value }, 'paymentStatus');
            }}
          />
        </div>
        <div className="column is-2">
          <Select
            label="Status"
            options={[
              { label: 'CANCELLED', value: 'CANCELLED' },
              { label: 'COMPLETED', value: 'COMPLETE' },
              { label: 'READY', value: 'READY' },
              { label: 'CONFIRMED', value: 'CONFIRMED' },
            ]}
            disableToastMessage
            value={search.status}
            onChange={e => {
              clearPagination();
              handlePush({ statusFilter: e.value }, 'statusFilter');
            }}
          />
        </div>
        <div className="column is-2">
          <Select
            label="Service"
            options={[
              { label: 'ALL', value: 'All' },
              { label: 'PICKUP', value: 'Pickup' },
              { label: 'DELIVERY', value: 'Delivery' },
              { label: 'DINEIN', value: 'Dinein' },
            ]}
            value={search.service}
            onChange={e => {
              clearPagination();
              handlePush({ service: e.value }, 'service');
            }}
          />
        </div>
      </div>
      <div className="columns">
        <div className="column is-3">
          <ReactDateTimePicker
            value={search.startDate}
            onChange={date => {
              clearPagination();
              handlePush(
                {
                  startDate: unformatted_localizedDate(
                    new Date(date),
                  ).toISOString(),
                },
                'startDate',
              );
            }}
            label="From Date"
            clear={false}
          />
        </div>

        <div className="column is-3">
          <ReactDateTimePicker
            value={search.endDate}
            label="To Date"
            onChange={date => {
              clearPagination();
              handlePush(
                {
                  endDate: unformatted_localizedDate(
                    new Date(date),
                  ).toISOString(),
                },
                'endDate',
              );
            }}
            clear={false}
          />
        </div>
      </div>
    </BoxWrapper>
  </Wrapper>
);
export default withRouter(PlaceSearch);
